import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Fade from "react-reveal/Fade";
//https://www.react-reveal.com/examples/

import Me from "../../assets/me2.jpg";
import Snippet from "../../assets/snippet.png";
import NetworkCode from "../../assets/network-code.png";
import { ReactComponent as GitHub } from "../../assets/svg/github.svg";
// import { ReactComponent as CodePen } from "../../assets/svg/codepen.svg";
// import { ReactComponent as ExternalLink } from "../../assets/svg/externallink.svg";

import Prj from "../Project-ul/Prj";

import "./Content.scss";
import "./Tab.scss";

var tabs = [
  {
    tabName: "Fastweb",
    role: "Qlik Sense Developer & Data Analyst at",
    roleLink: "https://www.fastweb.it/",
    roleCompany: "@Fastweb",
    period: "Mar 2024 - Today",
    mansions: [
      <>
        DB Management: Optimization, maintenance, and updating of the database
        to <span className="green"> ensure optimal </span> performance.
      </>,
      <>
        Creation and management of <span className="green"> ETL </span>{" "}
        (Extract, Transform, Load) processes for data extraction,
        transformation, and loading into the Qlik system.
      </>,
      <>
        Data Refinement (Medallion Architecture): Cleaning, transforming, and{" "}
        <span className="green"> improving data quality </span> to ensure
        reliability and accuracy.
      </>,
      <>
        <span className="green"> Dashboard Development: </span> Designing,
        implementing, and maintaining Qlik Sense dashboards for data analysis
        and reporting.
      </>,
      <>
        Data Analysis: Utilizing Qlik Sense for data analysis to provide{" "}
        <span className="green"> valuable insights </span> and support business
        decision-making.
      </>,
    ],
  },
  {
    tabName: "MB Academy",
    role: "Improving my skills at ",
    roleLink: "https://majorbit.com/",
    roleCompany: "@MajorBitGroup",
    period: "Aug 2023 - Feb 2024",
    mansions: [
      // "Managing multiple projects",
      <>
        Focusing on personal growth, next goal:
        <span className="green"> become a Flutter </span>
        developer
      </>,
      <>
        Achieved goal:
        <span className="green"> PCAP Python Certification </span>
      </>,
    ],
  },
  {
    tabName: "NTT Data",
    role: "Extension developer at",
    roleLink: "https://it.nttdata.com/",
    roleCompany: "@NTTData",
    period: "May 2021 - Jul 2023",
    mansions: [
      "Helping companies at choosing the right IT solution to satisfy a specific needing or to achieve a goal. Then develop it.",
      <>
        HTML, CSS/SCSS, Javascript, React JS, Angular JS, various libraries
        (mostly
        <span className="green">
          <a href="https://threejs.org/"> three.js</a>{" "}
        </span>
        and
        <span className="green">
          <a href="https://d3js.org/"> Data Driven Documents</a>{" "}
        </span>
        )
      </>,
    ],
  },
  {
    tabName: "Major Bit",
    role: "I.T. Consultant at",
    roleLink: "https://majorbit.com/",
    roleCompany: "@MajorBitGroup",
    period: "April 2021 - Today",
    mansions: [
      // "Here I started as a Junior SAS Developer. I experienced first hand the IT world and took a wide look of it.",
      "SAS Developer: Base, Macro, Enterprise Guide, Data Integration Studio, IML, Visual Analytics",
      "Working extensively on Oracle, SQL Server, MS Access. Using lots of mainly requested PROCS. Data extraction, transformation, loading. Read, write, import and export in another data format. Producing HTML, RTF, CSV and PDF formatted files using SAS/ODS.",
    ],
  },
];

var prjDesc = [
  {
    overline: "Last developed project",
    title: "Network",
    description:
      "The customer needed a data visualization to monitor the status of risks, their related KRI and hypothetical changes or impacts to the company. I thought to a mathematical structure to show relations between Risks in an aesthetically-pleasing way.",
    techlist: ["VSCode", "ES6", "D3"],
    links: [
      { img: <GitHub />, link: "https://github.com/G-development/network" },
      // { img: <CodePen />, link: "#" },
      // { img: <ExternalLink />, link: "#" },
    ],
    image: Snippet,
  },
  {
    overline: "Featured project",
    title: "IG Stories Bot",
    description:
      "A Telegram bot that, when n-persons you chase posted something on their IG automatically sends you a notification.",
    techlist: ["Javascript", "Python", "Scrapers"],
    links: [
      // { img: <CodePen />, link: "#" },
      // { img: <ExternalLink />, link: "#" },
    ],
    image: NetworkCode,
  },
];

const Content = () => {
  return (
    <div id="content">
      <main>
        <Fade top cascade>
          <section className="welcome">
            <h1>Hi, my name is</h1>
            <h2>Giovanni</h2>
            <h3>24yo, italian, coder.</h3>
            {/* <p>
              I’m just a guy who loves building (and occasionally designing) web
              things, of every genre.
            </p> */}
            <a className="btn" href="https://github.com/G-development">
              Visit my GitHub
            </a>
          </section>
        </Fade>

        <section id="about">
          <Fade top>
            <h2 className="numbered-heading">About me</h2>
          </Fade>
          <div className="inner">
            <div className="presentation">
              <Fade top cascade>
                <div>
                  <p>
                    Hello! My name is Giovanni and I love creating web things.
                    My interest in web development started about ten years ago,
                    at the <span className="green">little age of twelve!</span>{" "}
                    At first attempt I understood (on my own) how forum work,
                    and then
                    <span className="green"> started understanding</span> the
                    web world.
                  </p>
                  <p>
                    After that I <span className="green">assiduously</span>{" "}
                    cultivated my passion for IT, as a self-taught developer. Then, I
                    studied programming at school, and nowadays at university,
                    while working.
                  </p>
                  <p>
                    In the last year and a half I{" "}
                    <span className="green">started working</span> as an IT
                    Consultant with a thriving company.
                  </p>
                  <p>
                    Here are some of my <span className="green">everyday </span>
                    bread and butter!
                  </p>
                </div>
                <ul className="skills-list">
                  <li>Node.js</li>
                  <li>JavaScript (ES6+), jQuery</li>
                  <li>Python</li>
                  <li>React JS</li>
                  <li>Dart</li>
                </ul>
              </Fade>
            </div>
            <Fade>
              <div className="me">
                <img src={Me} alt="Me"/>
                <div className="overlay"></div>
              </div>
            </Fade>
          </div>
        </section>

        <section id="jobs">
          <Fade top cascade>
            <h2 className="numbered-heading">Experience</h2>
            <Tabs>
              <TabList>
                {tabs.map((tab, i) => (
                  <Tab key={i}>{tab.tabName}</Tab>
                ))}
              </TabList>

              {tabs.map((tab, i) => (
                <TabPanel key={i}>
                  <div className="panel-content">
                    <h2>
                      {tab.role}
                      <a href={tab.roleLink}>
                        <span className="green"> {tab.roleCompany}</span>
                      </a>
                    </h2>
                    <p>{tab.period}</p>
                    <ul>
                      {tab.mansions.map((el, i) => (
                        <li key={i}>{el}</li>
                      ))}
                    </ul>
                  </div>
                </TabPanel>
              ))}
            </Tabs>
          </Fade>
          {/* <a href="../archive">Click here</a> */}
        </section>

        <section id="projects">
          <Fade top>
            <h2 className="numbered-heading">Things I’ve built</h2>
          </Fade>
          <Prj prj={prjDesc} />
          {/* <NoteWorthy /> */}
        </section>

        <Fade top cascade>
          <section id="contact">
            <h2 className="numbered-heading">
              <span className="green">And now?</span>
            </h2>

            <h3>Get in touch</h3>
            <p>
              Although I’m not currently looking for any new opportunities, my
              inbox is always open. Whether you have a question or just want to
              say hi, I’ll try my best to get back to you!
            </p>
            <a className="btn" href="mailto:cuozzogiovanni03@gmail.com">
              Say hi!
            </a>
          </section>

          <div className="end">
            <p>
              Built with ❤️ and ☕<br />
              by Giovanni Cuozzo
            </p>
            <p>All Rights Reserved ©</p>
          </div>
        </Fade>
      </main>
    </div>
  );
};

export default Content;
